import Icon from 'veui/components/Icon'
import { IconStop } from 'dls-icons-vue'

Icon.register('stop', IconStop)
